import { gql } from '@apollo/client';

export function getExportVignetteRangesLookups() {
  return gql`
    query getExportVignetteRangesLookups {
      Insurance_VignetteRangeStatuses: __type(
        name: "Insurance_VignetteRangeStatuses"
      ) {
        name
        enumValues {
          name
        }
      }
      Insurance {
        queries {
          allAgencies {
            insurance_Agency_Id
            insurance_Agency_AgencyName
          }
          exportAgencyVignetteRange(
            SelectedAgencyID: []
            SelectedRangeStatus: []
            SelectedRangeYear: []
          ) {
            insurance_AgencyVignetteRange_RangeYear
          }
        }
      }
    }
  `;
}

export function exportAgencyVignetteRange() {
  return gql`
    query exportAgencyVignetteRange(
      $SelectedAgencyID: [String]
      $SelectedRangeStatus: [Insurance_VignetteRangeStatuses]
      $SelectedRangeYear: [Long]
    ) {
      Insurance {
        queries {
          exportAgencyVignetteRange(
            SelectedAgencyID: $SelectedAgencyID
            SelectedRangeStatus: $SelectedRangeStatus
            SelectedRangeYear: $SelectedRangeYear
          ) {
            insurance_AgencyVignetteRange_Id
            insurance_AgencyVignetteRange_RangeFrom
            insurance_AgencyVignetteRange_RangeTo
            insurance_AgencyVignetteRange_RangeStatus
            insurance_AgencyVignetteRange_RangeCode
            insurance_AgencyVignetteRange_RangeYear
            businessPartner_AgencyName
            businessPartner_UFACode
          }
        }
      }
    }
  `;
}
